var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"placeholder"},[_c('div',{staticClass:"placeholder-image"}),_c('div',{staticClass:"placeholder-lines"},_vm._l((_vm.lines),function(i){return _c('div',{key:i,style:('height: ' + _vm.lineSize + 'px')})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }